import { useEffect } from "react";
import SinglePageService from "../services/SinglePageServices";
import { ApiErrorHandler } from "../utils/ErrorHandler";
import useLocalStorage from "./useLocalStorage";

const useProjectSidebar = () => {
  const [projects, setProjects] = useLocalStorage('projectSidebar', []);

  const rehydrate = async () => {
    try {
      const reponse = await SinglePageService.getProjectSidebar();
      setProjects(reponse.data.projects);
    } catch (err) {
      const handler = ApiErrorHandler(err);
      console.log(handler.message);
    }
  }

  useEffect(() => {
    rehydrate();
  }, []);

  return { projects };

}

export default useProjectSidebar;